module.exports = __webpack_public_path__ + "img/member_print_description_bottom_icon.6ebafbf1.png";